// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"cc4e700e","852":"0ddd58ee","897":"fd2e6362"}[chunkId] + ".chunk.js";
};